import {
  stdModalHeaderBar, stdModalHeaderIconBox, stdModalHeaderTitle, stdModalCloseBtn,
} from '../adminlayout/designStandard';

// 모달 헤더 — 디자인 표준: 검정 밴드 + 아이콘 박스 + 흰 제목
// (카드 padding 24 안쪽에 있으므로 네거티브 마진으로 카드 모서리에 밀착, 라운드 12 = 카드와 동일)
export const headerBar = { ...stdModalHeaderBar(12), margin: '-24px -24px 16px' };
export const headerLeft = { display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 };
export const headerIconBox = stdModalHeaderIconBox;
export const headerTitle = stdModalHeaderTitle;
export const headerCloseBtn = stdModalCloseBtn;

export const overlay = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,.45)',
  zIndex: 1000,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  padding: '40px 12px',
  overflowY: 'auto',
};

export const modal = {
  background: 'var(--bg-card, #fff)',
  borderRadius: 12,
  padding: 24,
  width: '95%',
  maxWidth: 760,
  maxHeight: '90vh',
  overflowY: 'auto',
  boxShadow: '0 8px 32px rgba(0,0,0,.2)',
};

export const label = {
  fontSize: 12,
  fontWeight: 700,
  color: 'var(--text-muted)',
  marginBottom: 4,
  display: 'block',
};

export const input = {
  width: '100%',
  padding: '7px 10px',
  borderRadius: 6,
  border: '1px solid var(--border)',
  fontSize: 13,
  boxSizing: 'border-box',
  color: 'var(--text)',
  background: 'var(--bg-card)',
};

export const btn = (bg) => ({
  padding: '7px 16px',
  borderRadius: 6,
  border: 'none',
  cursor: 'pointer',
  fontWeight: 700,
  fontSize: 13,
  color: '#fff',
  background: bg,
});

export const section = { marginBottom: 16 };

export const rowBox = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: 10,
};
